"use client";

import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { X } from 'lucide-react';
import PricingPage from '@/components/pricing-page';

interface PlansModalProps {
  isOpen: boolean;
  onClose: () => void;
  currentPlan?: "free" | "plus" | "pro" | "elite";
  stripeAccount?: "new" | "old" | null;
  isEnterprise?: boolean;
  highlightEnterprise?: boolean;
  scrollToComparison?: boolean;
  onStartCancellation?: () => void;
}

const PlansModal: React.FC<PlansModalProps> = ({
  isOpen,
  onClose,
  currentPlan = "free",
  stripeAccount,
  isEnterprise = false,
  highlightEnterprise = false,
  scrollToComparison = false,
  onStartCancellation,
}) => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!isOpen || !mounted) return null;

  return createPortal(
    <div
      className="fixed inset-0 bg-black z-[60] flex justify-center items-start overflow-y-auto animate-in fade-in-0 duration-300"
      onClick={onClose}
    >
      <div
        className="relative w-full min-h-full overflow-y-auto p-2 sm:p-4 text-zinc-100 bg-transparent animate-in fade-in-0 slide-in-from-bottom-3 duration-500"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          className="absolute top-4 right-4 z-20 text-zinc-400 hover:text-zinc-200 hover:bg-zinc-800 p-2 rounded transition-all duration-200"
          onClick={onClose}
        >
          <X size={20} />
        </button>

        <PricingPage
          currentPlan={currentPlan}
          stripeAccount={stripeAccount ?? null}
          variant="modal"
          isEnterprise={isEnterprise}
          highlightEnterprise={highlightEnterprise}
          scrollToComparison={scrollToComparison}
          onStartCancellation={onStartCancellation}
        />
      </div>
    </div>,
    document.body,
  );
};

export default PlansModal;
